<template>
	<div class="d-tab-items" :class="{ bubbles: bubbles }">
		<slot></slot>
	</div>
</template>
<script>
export default {
	name: "imdex-tab-items",
	props: {
		value: {
			type: [Number, String]
		},
		bubbles: {
			type: Boolean
		}
	},
	data() {
		return {
			tabItems: []
		};
	}
};
</script>
<style lang="scss">
.d-tab-items {
	position: relative;
	width: 100%;
}
</style>
